<div *ngIf="withCheckboxSelection && checkedRowsId.size > 0 && withActions" class="multiple-rows-actions">
  <div class="left-container">
    <div>
      {{ expandFilterResultControl.value ? pageInfo.totalItems : checkedRowsId.size }}
      {{ 'tableActionsAndFilters.selectedRowsText' | labelsProvider }}
    </div>
    @if (withExpandFilters) {
      <div>
        {{ 'tableActionsAndFilters.expandResultsText' | labelsProvider }}
      </div>
      <mat-checkbox
        color="primary"
        [formControl]="expandFilterResultControl"
        (click)="$event.stopPropagation()"
        [matTooltip]="'common.violationsBulkTooltip' | labelsProvider"
        matTooltipPosition="below"
        matTooltipClass="tooltip-container"
      >
      </mat-checkbox>
    }
  </div>
  <app-actions-menu-select
    class="multi-actions"
    [actions]="(checkedRowsSupportedActions$ | async) ?? []"
    [forceUsingSelectOptions]="true"
    (actionOnClick)="multiCheckOnClick.emit($event)"
  >
  </app-actions-menu-select>
</div>

<p-table
  class="main-table"
  [ngClass]="{
    'clickable-table': withRowSelection,
    'checked-rows-visible': checkedRowsId.size > 0,
  }"
  [tableStyle]="{
    'table-layout': 'fixed',
    width: '100%',
  }"
  (keydown.escape)="onEscKey($event)"
  [value]="(data$ | async) ?? []"
  selectionMode="single"
  metaKeySelection="true"
  [columns]="selectedColumns()"
  [lazy]="true"
  (onLazyLoad)="onLazyLoad($event)"
  [paginator]="true"
  [rows]="rowsPerPage ?? undefined"
  [scrollable]="true"
  [totalRecords]="pageInfo.totalItems"
  [loading]="isLoading"
  [resizableColumns]="true"
  columnResizeMode="expand"
  (onColResize)="checkTruncation()"
  (clickOutside)="clickedOutside($event)"
  [customSort]="true"
  [sortField]="sortKey"
  [sortOrder]="sortOrder"
  (sortFunction)="onSortClick($event)"
  [showCurrentPageReport]="true"
  currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
  [showFirstLastIcon]="false"
  [pageLinks]="1"
>
  <ng-template pTemplate="header" let-columns>
    <tr>
      <!-- Check box column -->
      <th *ngIf="withCheckboxSelection" style="width: 50px">
        <mat-checkbox
          color="primary"
          [formControl]="allCheckedControl"
          (click)="$event.stopPropagation()"
        ></mat-checkbox>
      </th>
      <!-- Platform icon column -->
      <th *ngIf="tabelWithIcon" style="width: 50px"></th>
      <ng-container *ngFor="let col of columns">
        <th
          *ngIf="col.sortKey"
          pResizableColumn
          [pSortableColumn]="col.sortKey"
          [ngStyle]="{
            width: col.width + 'px',
          }"
        >
          {{ col.header }}
          <p-sortIcon [field]="col.sortKey"></p-sortIcon>
        </th>
        <th
          *ngIf="!col.sortKey"
          pResizableColumn
          [ngStyle]="{
            width: col.width + 'px',
          }"
        >
          {{ col.header }}
        </th>
      </ng-container>
      <!-- Actions Column -->
      <th *ngIf="withActions" style="width: 100px"></th>
    </tr>
  </ng-template>

  <ng-template pTemplate="body" let-row let-columns="columns">
    <tr
      [pSelectableRow]="row"
      class="table-row"
      [class.p-highlight]="row === selectedRow()"
      (focus)="onRowFocus($event, row)"
      (keydown.arrowup)="selectRowByArrowKey($event, Direction.UP)"
      (keydown.arrowdown)="selectRowByArrowKey($event, Direction.DOWN)"
      (click)="onRowClicked($event, row)"
    >
      <td *ngIf="withCheckboxSelection" style="width: 50px">
        <mat-checkbox
          (click)="$event.stopPropagation()"
          [checked]="checkedRowsId.has(row.rowId)"
          (change)="onCheckboxClick(row.rowId)"
          [disabled]="expandFilterResultControl.value"
        >
        </mat-checkbox>
      </td>
      <td *ngIf="tabelWithIcon" style="width: 50px">
        <img class="icon-field" [src]="row.platformIcon" [alt]="row.platform" />
      </td>
      <td
        *ngFor="let col of columns"
        [ngSwitch]="col.type"
        [ngStyle]="{
          width: col.width + 'px',
        }"
      >
        <img *ngSwitchCase="tableColumnTypeEnum.Icon" class="icon-field" [src]="row[col.prop]" />
        <app-severity-label
          *ngSwitchCase="tableColumnTypeEnum.SeverityLabel"
          [severity]="row[col.prop]"
        ></app-severity-label>
        <app-status-label
          *ngSwitchCase="tableColumnTypeEnum.StatusLabel"
          [statusLabel]="row[col.prop]"
        ></app-status-label>
        <app-view-labels-multi-select
          *ngSwitchCase="tableColumnTypeEnum.Label"
          [labelBindings]="row[col.prop]"
          [canBeRemoved]="false"
          [areMerged]="true"
          [multipleRows]="false"
        >
        </app-view-labels-multi-select>
        <app-multiple-tags
          *ngSwitchCase="tableColumnTypeEnum.Tag"
          [tags]="row[col.prop].toString().trim()"
        ></app-multiple-tags>
        <app-possible-na-cell
          #cellRef
          *ngSwitchCase="tableColumnTypeEnum.TextOrNA"
          [text]="row[col.prop]"
          [toolTip]="row[col.tooltipDynamicText]"
          [attr.data-row-id]="row.rowId"
          [attr.data-col-key]="col.prop"
          matTooltip="{{ row[col.prop] }}"
          matTooltipPosition="below"
          [matTooltipDisabled]="!isTruncated(row.rowId, col.prop)"
          class="ellipsis"
        >
        </app-possible-na-cell>
        <app-possible-na-multi-value-cell
          #cellRef
          *ngSwitchCase="tableColumnTypeEnum.MultiValueOrNA"
          [values]="row[col.prop]"
          [toolTip]="row[col.tooltipDynamicText]"
          [attr.data-row-id]="row.rowId"
          [attr.data-col-key]="col.prop"
          matTooltip="{{ row[col.prop] }}"
          matTooltipPosition="below"
          [matTooltipDisabled]="!isTruncated(row.rowId, col.prop)"
          class="ellipsis"
        >
        </app-possible-na-multi-value-cell>
        <ng-container *ngSwitchCase="tableColumnTypeEnum.CopyableText">
          <app-copy-button
            *ngIf="!col.iconOnly"
            [value]="
              col.toCapitalize
                ? (row[col.prop].toString().trim() | beautifyDisplayString)
                : row[col.prop].toString().trim()
            "
            text="{{
              col.customCopyButtonTextLabel
                ? (col.customCopyButtonTextLabel | labelsProvider)
                : col.toCapitalize
                  ? (row[col.prop].toString().trim() | beautifyDisplayString)
                  : row[col.prop].toString().trim()
            }}"
            [isSecondaryFontColor]="true"
            [successPopupPosition]="copyButtonPopupPosition"
            [withCopyIcon]="col.withCopyIcon ? true : false"
          >
          </app-copy-button>
          <app-copy-button
            *ngIf="col.iconOnly ? true : false"
            [value]="
              col.toCapitalize
                ? (row[col.prop].toString().trim() | beautifyDisplayString)
                : row[col.prop].toString().trim()
            "
            [isSecondaryFontColor]="true"
            [successPopupPosition]="copyButtonPopupPosition"
            [title]="
              col.toCapitalize
                ? (row[col.prop].toString().trim() | beautifyDisplayString)
                : row[col.prop].toString().trim()
            "
          >
          </app-copy-button>
        </ng-container>

        <app-anchor-link
          *ngSwitchCase="tableColumnTypeEnum.LinkNewPage"
          [navigation]="row[col.linkPropertyKey]"
          class="prime-table__link-cell"
        >
          <span
            #cellRef
            [attr.data-row-id]="row.rowId"
            [attr.data-col-key]="col.prop"
            matTooltip="{{ row[col.prop] }}"
            matTooltipPosition="below"
            [matTooltipDisabled]="!isTruncated(row.rowId, col.prop)"
            class="link ellipsis"
            >{{ row[col.prop] }}</span
          >
        </app-anchor-link>

        <div
          *ngSwitchCase="tableColumnTypeEnum.Date"
          #cellRef
          [attr.data-row-id]="row.rowId"
          [attr.data-col-key]="col.prop"
          matTooltip="{{ row[col.prop] }}"
          matTooltipPosition="below"
          [matTooltipDisabled]="!isTruncated(row.rowId, col.prop)"
          class="ellipsis"
        >
          {{ row[col.prop] ? (row[col.prop] | date: 'mediumDate') : '' }}
        </div>
        <div
          *ngSwitchCase="tableColumnTypeEnum.DateTime"
          #cellRef
          [attr.data-row-id]="row.rowId"
          [attr.data-col-key]="col.prop"
          matTooltip="{{ row[col.prop] }}"
          matTooltipPosition="below"
          [matTooltipDisabled]="!isTruncated(row.rowId, col.prop)"
          class="ellipsis"
        >
          {{ row[col.prop] ? (row[col.prop] | date: 'medium') : '' }}
        </div>
        <div
          *ngSwitchCase="tableColumnTypeEnum.TextWithIconAndTooltip"
          style="display: flex; align-items: center"
          #cellRef
          [attr.data-row-id]="row.rowId"
          [attr.data-col-key]="col.prop"
          matTooltip="{{ row[col.prop] }}"
          matTooltipPosition="below"
          [matTooltipDisabled]="!isTruncated(row.rowId, col.prop)"
          class="ellipsis"
        >
          {{ col.toCapitalize ? (row[col.prop] | beautifyDisplayString) : row[col.prop] }}
          <div>
            <img
              class="status-label-icon"
              [src]="row[col.iconSrc]"
              [matTooltip]="row[col.tooltipIconText]"
              *ngIf="row[col.tooltipIconText]"
              style="padding-top: 9px"
            />
          </div>
        </div>
        <!-- Text with Icon -->
        <div
          *ngSwitchCase="tableColumnTypeEnum.TextWithIcon"
          class="text-with-icon"
          style="display: flex; align-items: center"
        >
          <img class="icon-field" [src]="row[col.iconSrc]" style="margin-right: 5px" />
          <div [ngStyle]="{ color: row[col.textColor] ? row[col.textColor] : null }">
            {{ col.toCapitalize ? (row[col.prop] | beautifyDisplayString) : row[col.prop] }}
          </div>
        </div>
        <div
          *ngSwitchCase="tableColumnTypeEnum.TextPopup"
          (click)="openDialog(row[col.textPopupTitleKey], row[col.textPopupTextKey])"
          class="clickable-column"
        >
          {{ row[col.prop] }}
        </div>
        <div
          *ngSwitchDefault
          #cellRef
          [attr.data-row-id]="row.rowId"
          [attr.data-col-key]="col.prop"
          matTooltip="{{ row[col.prop] }}"
          matTooltipPosition="below"
          [matTooltipDisabled]="!isTruncated(row.rowId, col.prop)"
          class="ellipsis"
        >
          <!-- <div ></div> -->
          {{ col.toCapitalize ? (row[col.prop] | beautifyDisplayString) : row[col.prop] }}
        </div>
      </td>
      <td style="width: 50px" *ngIf="withActions">
        <div class="actions-column-icon" (click)="$event.stopPropagation()">
          <app-actions-menu-icon
            *ngIf="row.menuActions.length > 0"
            class="actions-icon"
            [actions]="row.menuActions"
            (actionOnClick)="actionOnClick($event, row)"
            [smallSize]="true"
          >
          </app-actions-menu-icon>
        </div>
      </td>
    </tr>
  </ng-template>
  <!-- When the table is empty ( data length 0) we get here -->
  <ng-template pTemplate="emptymessage">
    <app-no-data [tableNotFoundText]="tableNotFoundText" [tableNotFoundIcon]="tableNotFoundIcon"></app-no-data>
  </ng-template>
</p-table>
